import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Box } from '@rebass/grid';
import { H1, H2 } from 'app/ui_components/tags';
import { isMobile, isTablet } from 'app/helpers/utils';

export default class WithTitle extends React.Component {
  static propTypes = {
    // If we want the children of WithTitle to inherit it's layout
    childrenInheritLayout: PropTypes.bool.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    textAlign: PropTypes.string,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]).isRequired,
    mb: PropTypes.number.isRequired,
    mt: PropTypes.number.isRequired,
    smallTitleOnMobile: PropTypes.bool.isRequired,
    id: PropTypes.string,
    maxWidth: PropTypes.number.isRequired,
    // if the child contents are shifted over the title hero
    shiftUp: PropTypes.number.isRequired,
    width: PropTypes.array.isRequired,
    minTitleHeight: PropTypes.number.isRequired,
  };

  static defaultProps = {
    textAlign: 'center',
    childrenInheritLayout: false,
    mb: 0,
    mt: isTablet ? 220 : isMobile ? 40 : 160,
    smallTitleOnMobile: false,
    shiftUp: 0,
    width: [1, 4 / 5, 3 / 5],
    minTitleHeight: -1,
    // none
    maxWidth: -1
  };

  constructor(props) {
    super(props);
    this.state = {
      // we need to calculate specific margins
      // because of the topbar being position:fixed
      topHeight: 0
    };
    this.layout = {
      mx: 'auto',
      px: ['20px', 0],
    };
  }

  componentDidMount() {
    const topHeight = document.getElementById('topbar').clientHeight;
    this.setState({ topHeight });
  }

  setMargins() {
    const { mt, shiftUp } = this.props;
    const { topHeight } = this.state;
    const top = parseInt(mt + topHeight);
    const bottom = mt + shiftUp * -1;
    return { top, bottom };
  }

  render() {
    const {
      props: {
        title,
        subtitle,
        textAlign,
        children,
        childrenInheritLayout,
        mb,
        smallTitleOnMobile,
        id,
        maxWidth,
        width,
        minTitleHeight,
      },
    } = this;
    const { top: bufferedMarginTop, bottom: bufferedMarginBottom } = this.setMargins();

    let { layout } = this;
    layout = Object.assign(layout, { width });
    return (
      <React.Fragment>
        <Flex
          justifyContent="center"
          flexDirection="column"
        >
          {/* Add 60 to mt to account for fixed topbar */}
          <Box
            {...layout}
            mt={bufferedMarginTop}
            mb={!subtitle ? bufferedMarginBottom : mb}
            style={{ maxWidth: maxWidth }}
          >
            <H1
              id="title"
              style={{ textAlign, minHeight: minTitleHeight }}
              smallOnMobile={smallTitleOnMobile}
            >
              {title}
            </H1>
          </Box>
          {subtitle && (
            <Box
              {...layout}
              mt={isMobile ? 30 : 36}
              mb={mb !== 0 ? mb : bufferedMarginBottom}
            >
              <H2 style={{ textAlign: textAlign }} id="subtitle">
                {subtitle}
              </H2>
            </Box>
          )}
        </Flex>
        {children &&
          (childrenInheritLayout
            ? React.Children.map(children, child =>
                React.cloneElement(children, {
                  id,
                  ...layout,
                  style: { maxWidth: maxWidth },
                }),
              )
            : React.cloneElement(children, { id }))}
      </React.Fragment>
    );
  }
}
